import { t } from "../../hooks/useAppTranslation";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import {
  activateControllingEntity,
  createControllingEntity,
  deactivateControllingEntity,
} from "../../Redux/Actions/ControllingEntitySubjects";
import { IDictionary } from "../ExternalControl/ExternalControlContainer";
import PopUp from "../PopUp/PopUp";
import { DictsListForm } from "./DictsListForm";
import { NewDictValueForm } from "./NewDictValueForm";

type Props = {
  setVisibility(): void;
};

type PopupProps = {
  title?: string;
  message?: string;
  type?: string;
  onClick?(): void;
  onClose?(): void;
};

export const DictionaryFormContainer: React.FC<Props> = ({ setVisibility }) => {  
  const [formType, setFormType] = useState("DictsList");
  const [popup, setPopup] = useState({
    message: "",
    type: "custom",
    title: "external-controls-dialog-add-controlling-body",
    onClose: setVisibility,
    onClick: () => {},
  });

  const dispatch = useAppDispatch();
  const controllingEntitySubjects = useAppSelector(
    (state) => state.controllingEntitySubjects
  );
  const controllingSubjects: IDictionary[] =
    controllingEntitySubjects.controllingEntitySubjects;

  const showPopup = ({
    title,
    message,
    type,
    onClick,
    onClose,
  }: PopupProps) => {
    setPopup((prevState: any) => {
      return {
        ...prevState,
        title,
        message,
        type,
        onClick,
        onClose,
      };
    });
  };

  const showDictsListPopup = () => {
    setFormType("DictsList");
    showPopup({
      type: "custom",
      title: t('external-controls-dialog-add-controlled-entity'),
      onClose: setVisibility,
    });
  };

  const showConfirmPopup = (checked: boolean, dict: IDictionary) => {
    setFormType("Other");
    showPopup({
      title: t('g-notification'),
      type: "confirm",
      message: `${checked ? t('external-controls-dialog-activate') : t('external-controls-dialog-deactivate')}: ${dict.description}?`,
      onClick: () => handleChangeStateControllingSubject(checked, dict.entryId),
      onClose: () => {
        showDictsListPopup();
      },
    });
  };

  const showErrorPopup = () => {
    setFormType("Other");
    showPopup({
      title: t('g-error'),
      type: "error",
      message: t('external-controls-dialog-read-write-failed'),
      onClick: setVisibility,
      onClose: setVisibility,
    });
  };

  const showSuccessPopup = () => {
    setFormType("Other");
    showPopup({
      title: t('g-success'),
      type: "notify",
      message: t('g-data-saved'),
      onClick: setVisibility,
      onClose: setVisibility,
    });
  };

  const handleNewControllingSubject = (values: any) => {
    dispatch(createControllingEntity(values));
    showDictsListPopup();
  };

  const handleChangeStateControllingSubject = (
    checked: boolean,
    id: number
  ) => {
    if (checked) {
      dispatch(activateControllingEntity(id));
    } else {
      dispatch(deactivateControllingEntity(id));
    }
  };

  useEffect(() => {
    if (controllingEntitySubjects.isError) {
      showErrorPopup();
    }
  }, [controllingEntitySubjects.error]);


  return (
    <>
      {formType === "DictsList" && (
        <PopUp
          type={popup.type}
          title={t(popup.title)}
          closePopUp={popup.onClose}
          onClickEvent={popup.onClick}
          notification={
            <div className='popUp__content-scrolled'>
              <DictsListForm
                handleChangeDictValue={async (dict, checked) => {
                  showConfirmPopup(checked, dict);
                }}
                data={controllingSubjects}
                handleNewDictValue={() => setFormType("NewDictValue")}
              />
            </div>
          }
        />
      )}
      {formType === "NewDictValue" && (
        <PopUp
          type={popup.type}
          title={t(popup.title)}
          closePopUp={popup.onClose}
          onClickEvent={popup.onClick}
          notification={
            <NewDictValueForm
              handleSaveDict={handleNewControllingSubject}
              handleClose={() => setFormType("DictsList")}
              label={t('external-controls-controlling-body')}
            />
          }
        />
      )}

      {formType === "Other" && (
        <PopUp
          type={popup.type}
          title={t(popup.title)}
          closePopUp={popup.onClose}
          onClickEvent={popup.onClick}
          notification={<p>{popup.message}</p>}
        />
      )}
    </>
  );
};
